// extracted by mini-css-extract-plugin
module.exports = {"betSlip":"_73ed17a","content":"_7fc1b4e","emptyBetSlip":"_b6e34f6"};